<template>
  <div>
    reports-config
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>

</style>
